import { useEffect, useState } from "react";
import {
  getDerivedIntelEngine,
  type DerivedSnapshot,
  type MatchSample,
} from "./derivedIntelligenceEngine";

/**
 * Cheap polling hook — recomputes derived snapshot at most once per
 * `intervalMs` (default 2s). Tolerant to API delay.
 */
export function useDerivedSnapshot(intervalMs = 2000): DerivedSnapshot {
  const [snap, setSnap] = useState<DerivedSnapshot>(() =>
    getDerivedIntelEngine().snapshot(Date.now(), intervalMs),
  );
  useEffect(() => {
    const id = window.setInterval(() => {
      setSnap(getDerivedIntelEngine().snapshot(Date.now(), intervalMs));
    }, intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return snap;
}

/** Helper for simulation/feed code to push a sample without coupling. */
export function ingestDerivedSample(sample: MatchSample): void {
  getDerivedIntelEngine().ingest(sample);
}